var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "question-container" },
    [
      _c("div", [_c("span", { domProps: { innerHTML: _vm._s(_vm.text) } })]),
      _c("Scale", {
        attrs: { num: 5, answer: _vm.answer },
        on: { sendAnswer: _vm.submitAnswer }
      }),
      _c("CommentBox", {
        key: _vm.commentKey,
        attrs: { questionId: _vm.questionId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }